import {BrowserRouter, Route, Switch} from "react-router-dom";
import Home from "./pages/Home/Home";
import DepotEditor from "./pages/DepotEditor/DepotEditor";

export default function Router() {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/">
                    <Home />
                </Route>
                <Route exact path="/depot/:id">
                    <DepotEditor />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}
